import React, { useState } from "react";
import {ComposedModal, ModalHeader, ModalBody, ModalFooter, Button, InlineLoading} from 'carbon-components-react';
import ClaycoForm from "./clayco-form";
import { useFormContext } from "react-hook-form";

const EditModal = ({title, show, setShow, schema, onSubmit, onError, children, focusElement}) => {
    const [submitting, setSubmitting] = useState(false);
    const submit = async(formData) => {
        setSubmitting(true);
        await onSubmit(formData);
        handleClose();
        setSubmitting(false);
    }

    const error = (errors, e) => {
        console.log("Form Submission Error", errors);
        if(onError)
            onError(errors, e);
    }

    const handleClose = () => {      
        setShow(false); 
    }

    return(
        <ClaycoForm schema={schema} onSubmit={submit} onError={error}>
            <ComposedModal 
                open={show} 
                onClose={handleClose}
                preventCloseOnClickOutside 
                selectorPrimaryFocus={focusElement}
            >
                <ModalHeader title={title} closeModal={handleClose} />
                <ModalBody aria-label="Body" hasScrollingContent>
                        {children}
                </ModalBody>
                <ModalFooter>
                    <Button kind="secondary" disabled={submitting} onClick={handleClose}>Cancel</Button>
                    <Button type="submit" disabled={submitting}>
                        {submitting ?
                            <InlineLoading description="Submitting..." />
                        :
                            <>Save</>
                        }
                    </Button>
                </ModalFooter>
            </ComposedModal>
        </ClaycoForm>
    )
}

export default EditModal;